import React from "react";
import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_orderup-renova/artifacts/7qn35fi5_foodgo.png";

export default function Logo({ size = "md", linked = true, className = "" }) {
  const heights = { sm: "h-16", md: "h-28 sm:h-32", lg: "h-44 sm:h-56", xl: "h-64 sm:h-72" };
  const h = heights[size] || heights.md;
  const img = (
    <img
      src={LOGO_URL}
      alt="FoodGo by Renova 360"
      className={`${h} w-auto block drop-shadow-[0_0_40px_rgba(255,145,0,0.55)] ${className}`}
      data-testid="brand-logo-img"
      draggable={false}
    />
  );
  if (!linked) return img;
  return (
    <Link to="/" className="inline-flex items-center" data-testid="brand-logo">
      {img}
    </Link>
  );
}
